const Data = [
  {
    name: "Nitish Jindal",
    position: "Finance Head",
    imageUrl: "/assets/images/members/Heads26/NitishJindal.jpg",
    facebookLink: "",
    email: "nitishjindal.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/nitish-jindal-345b01324?utm_source=share_via&utm_content=profile&utm_medium=member_android"
  },
  {
    name: "Preeti Choudhary",
    position: "Finance Head",
    imageUrl: "/assets/images/members/Heads26/PreetiChoudhary.jpg",
    facebookLink: "",
    email: "preeti.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/preeti-choudhary-0abb1a21a"
  },
  {
    name: "Srijan Yadav",
    position: "Finance Head",
    imageUrl: "/assets/images/members/Heads26/SrijanYadav.jpg",
    facebookLink: "",
    email: "srijan01.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/srijan-yadav-b60738270?utm_source=share_via&utm_content=profile&utm_medium=android_app"
  }
];

export default Data;